
export const Globals = {

};